import {z} from '@hono/zod-openapi';

import {nissanDiglasStructuredSourceSchema} from '../nissan/nissanDiglasStructuredSourceSchema';
import {
  extractDeliveryNoteDocumentOpenAIResultSchema,
  extractDeliveryNoteDocumentItemSchema,
} from './ExtractDeliveryNoteDocumentOpenAIResult';

const itemSchema = extractDeliveryNoteDocumentItemSchema.extend({
  discount: z.number().nullable(),
  sourceLineNumber: z.number().int().positive().optional(),
});

export const extractDeliveryNoteDocumentResultSchema =
  extractDeliveryNoteDocumentOpenAIResultSchema.extend({
    structuredSource: nissanDiglasStructuredSourceSchema.optional(),
    listOfItems: z.array(
      z.object({
        items: z.array(itemSchema),
        pageNumber: z.number(),
      })
    ),
  });

export type ExtractDeliveryNoteDocumentResult = z.infer<
  typeof extractDeliveryNoteDocumentResultSchema
>;
